import { AudioManager } from "../../AudioManager";
import { Button } from "../../utils/Button";
import { BootScene } from "../BootScene";
import { ShopContainer } from "./ShopContainer";

export class ShopLid extends Phaser.GameObjects.Container {

    private lidType: string;
    private activeButton: Button;
    private inactiveButton: Button;
    private activeText: Phaser.GameObjects.Text;
    private inactiveText: Phaser.GameObjects.Text;
    private shopContainer: ShopContainer;

    constructor(scene: Phaser.Scene, lidType: string, shopContainer: ShopContainer) {

        super(scene);

        this.lidType = lidType;
        this.shopContainer = shopContainer;

        this.activeButton = new Button(this.scene, 10, 10, "texture_atlas_1", "btn_lid_shop_active_off", "btn_lid_shop_active_on");
        this.activeButton.onDown(this.onClickButton, this);
        this.add(this.activeButton);

        const gameText = this.scene.game.cache.json.get("game-text");

        let labelStr = this.lidType === ShopItem.BOARD ? gameText.BOARDS : gameText.STRIKERS;

        this.activeText = new Phaser.GameObjects.Text(this.scene, 8, 12 + (BootScene.textYgap * -51), labelStr, { fontFamily: "Teko-Medium", fontSize: "42px", color: "#FFFFFF" });
        this.activeText.setOrigin(.5,BootScene.originY);
        this.add(this.activeText);

        this.inactiveButton = new Button(this.scene, 10, 10, "texture_atlas_1", "btn_lid_shop_inactive_off", "btn_lid_shop_inactive_on");
        this.inactiveButton.onDown(this.onClickButton, this);
        this.add(this.inactiveButton);

        this.inactiveText = new Phaser.GameObjects.Text(this.scene, 8, 12 + (BootScene.textYgap * -51), labelStr, { fontFamily: "Teko-Medium", fontSize: "42px", color: "#3A68AF" });
        this.inactiveText.setOrigin(.5,BootScene.originY);
        this.add(this.inactiveText);
    }

    public activate(): void {

        this.activeButton.visible = true;
        this.activeText.visible = true;

        this.inactiveButton.visible = false;
        this.inactiveText.visible = false;
    }

    public deactivate(): void {

        this.activeButton.visible = false;
        this.activeText.visible = false;

        this.inactiveButton.visible = true;
        this.inactiveText.visible = true;
    }

    private onClickButton(): void {

        AudioManager.playSound("click_btn");

        this.shopContainer.onClickLid(this.lidType);
    }
}
